import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  errorText: {
    color: theme.palette.accentError,
  },
  unassignedForm: {
    marginLeft: pxToRem(24),
    marginTop: pxToRem(24),
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    marginTop: pxToRem(15),
  },
  loadingSpinner: {
    marginLeft: pxToRem(10),
  },
});
